module.exports = __webpack_public_path__ + "static/favicon-32x32-a88fa199de540454c76e3f3c54ab1256.png";